import './App.css';
import MatrixRain from './components/binarybg';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Timeline from './components/Timeline';
import Prizes from './components/Prizes';
import Sponsors from './components/Sponsors';
import Footer from './components/Footer';
import Countdown from './components/Countdown';

function App() {
  return (
    <div>
      <MatrixRain />
      <Navbar />
      <Home />
      <Countdown />
      <Timeline />
      {/* <Prizes />
      <Sponsors /> */}
      <Footer />
    </div>
  );
}

export default App;


// import MatrixRain from "./components/binarybg";

// function App() {
//   return (
//     <>
//       {/* <MatrixRain /> */}
      
//     </>
//   );
// }

// export default App;